import CheckinColor from './CheckinColour.svg';
import CheckinDark from './CheckinDark.svg';
import CheckinLight from './CheckinLight.svg';
export const checkin = { color: CheckinColor, dark: CheckinDark, light: CheckinLight };
//# sourceMappingURL=index.js.map